/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, amount: NonNullable<unknown> }} Partner_Admin_Billing_PileInputs */



/**
* | output |
* | --- |
* | "{count} closed reports · {amount} uninvoiced" |
*
* @param {Partner_Admin_Billing_PileInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_billing_pile = /** @type {((inputs: Partner_Admin_Billing_PileInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Billing_PileInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} abgeschlossene Berichte · ${i?.amount} nicht abgerechnet`)
	return /** @type {LocalizedString} */ (`${i?.count} closed reports · ${i?.amount} uninvoiced`)
});